import { color } from '../../../../../../utility/constant/color.constant'
import { cover } from '../../../../../../utility/constant/helper.constant'
import { useMontage } from '../../../../../../context/montage.context'
import { Helper, Status, WindowElement } from '../../../../../../classes/helper'
import { useEffect } from 'react'

interface Props {
  positionX: number
}

export const WindowsFrontGlass = ({ positionX }: Props) => {
  const { measure, sidewall, ego, night } = useMontage()
  const startPosition = -measure.userWidth / 2
  const isMoonRoof = Status.sidewallDoorFront(sidewall)

  const windowFrontPosition = isMoonRoof
    ? WindowElement.moonPosition(positionX, measure) - 12
    : 0

  const delta =
    measure.windowsFrontWidth / 2 +
    (positionX + cover.bar.width / 200) * measure.windowsFrontWidth

  return (
    <group position={[0, 0, Helper.convertToMeter(windowFrontPosition)]}>
      <mesh
        position={[
          Helper.convertToMeter(startPosition + delta),
          Helper.convertToMeter(measure.frontHeight / 2),
          Helper.convertToMeter(measure.userDepth! - cover.bar.depth / 2 + 0.5),
        ]}
        rotation={[Helper.convertAngleToRadiant(90), 0, 0]}
      >
        <boxGeometry
          args={[
            Helper.convertToMeter(
              measure.windowsFrontWidth +
                Helper.windowOverlap(measure, isMoonRoof, positionX)
            ),
            Helper.convertToMeter(cover.bar.depth / 10),
            Helper.convertToMeter(measure.frontHeight - cover.bar.height / 2),
          ]}
        />
        <meshPhysicalMaterial
          color={color.white}
          envMapIntensity={ego?.ego || night?.night? 0.02:0.8}
          transparent
          opacity={ego?.ego || night?.night? 0.4: 0.3}
          metalness={ego?.ego || night?.night? 0.5 : 0.75}
          roughness={0}
        />
      </mesh>
    </group>
  )
}
